/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Fahrzeugmarke und -modell`
};

const en_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Car model and brand`
};

const es_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Marca y modelo del vehículo`
};

const fr_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Marque et modèle`
};

const it_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Marca e modello del veicolo`
};

const nl_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Merk en model van het voertuig`
};

const pt_register_car__search_placeholder = /** @type {(inputs: {}) => string} */ () => {
	return `Marca e modelo do veículo`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const register_car__search_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.register_car__search_placeholder(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("register_car__search_placeholder", locale)
	if (locale === "de") return de_register_car__search_placeholder(inputs)
	if (locale === "en") return en_register_car__search_placeholder(inputs)
	if (locale === "es") return es_register_car__search_placeholder(inputs)
	if (locale === "fr") return fr_register_car__search_placeholder(inputs)
	if (locale === "it") return it_register_car__search_placeholder(inputs)
	if (locale === "nl") return nl_register_car__search_placeholder(inputs)
	return pt_register_car__search_placeholder(inputs)
};